export default "__VITE_ASSET__DtHl5wDc__"